import {Component, inject, signal} from '@angular/core';
import {CommonModule} from '@angular/common';
import {CampaignsApiService} from '@core/services/api/campaigns-api.service';
import {KanbanBoardComponent, KanbanConfig} from '@shared/components/commons/kanban-board/kanban-board.component';

@Component({
    selector: 'app-my-panel',
    standalone: true,
    imports: [
        CommonModule,
        KanbanBoardComponent
    ],
    templateUrl: './my-panel.component.html',
    styleUrl: './my-panel.component.scss'
})
export class MyPanelComponent {
    private campaignsApiService = inject(CampaignsApiService);

    protected totalTasks = signal<number>(0);

    // Kanban configuration
    protected kanbanConfig: KanbanConfig = {
        loadTasksFn: (params: any) => this.campaignsApiService.getMyTasks(params),
        showAssigneeFilter: false,
        showSearch: true,  // Enable search for finding companies
        allowAssigneeManagement: false,  // User cannot change assignees in their own panel
        allowRemoveFromCampaign: false   // User cannot remove tasks from campaigns
    };

    protected onTasksLoaded(total: number): void {
        this.totalTasks.set(total);
    }
}
